import { useIntl } from 'react-intl'

import ButtonCinestar from '../../../../../../../../components/Buttons/ButtonCinestar/ButtonCinestar'
import Typography from '../../../../../../../../components/Typography/Typography'
import InfoWindow from '../../../../../../../../components/Windows/InfoWindow/InfoWindow'

import './ClubSummaryVouchers.scss'

const ClubSummaryRewards = ({ rewards, userPoints }) => {
    const intl = useIntl()

    return (
        <div className="club-summary-vouchers d-flex">
            {rewards.length > 0 ? (
                rewards?.map(({ name, points }, i) => (
                    <div key={i} className="voucher-card d-flex flex-column justify-content-between">
                        <div className="voucher-card--header d-flex flex-column align-items-center text-center">
                            <img
                                src="images/cinestar/popcorn-menu.png"
                                alt="popcorn-menu"
                                className="w-100 px-4 mb-4 h-auto"
                            />
                            <Typography variant={'h2'}>{name}</Typography>
                            <Typography variant={'p'} color={'whiteTransparent'}>
                                Popis... Tento text bude casom nahradeny textom z backendu.
                            </Typography>
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                            <Typography variant={'subtitle'} className={'text-nowrap pe-3'}>
                                {intl.formatMessage({ id: 'global.currency.points' }, { points })}
                            </Typography>

                            <ButtonCinestar variant={'primary-v2'} className={'px-3'} disabled={userPoints < points}>
                                {intl.formatMessage({ id: 'buttons.apply' })}
                            </ButtonCinestar>
                        </div>
                    </div>
                ))
            ) : (
                <InfoWindow
                    color={'transparent'}
                    description={intl.formatMessage({ id: 'userProfile.cinestarClub.rewards.noRewards' })}
                />
            )}
        </div>
    )
}

export default ClubSummaryRewards
